import {Injectable} from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService as OktaAuthService} from '@auth0/auth0-angular';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class OktaAuthGuard implements CanActivate {
  constructor(
    private oktaAuth: OktaAuthService,
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const organization = next.data['organization'];
    console.log('OktaAuthGuard: canActivate', organization);

    this.oktaAuth.isAuthenticated$.subscribe(isAuthed => {
      console.log('OktaAuthGuard: isAuthenticated', isAuthed);
      if (!isAuthed && organization && environment.oktaOrganization.hasOwnProperty(organization)) {
        console.log('OktaAuthGuard: Redirecting to Okta login for organization:', organization);
        this.oktaAuth.loginWithRedirect({
          appState: {target: '/login/okta/auth'},
          authorizationParams: {
            organization: environment.oktaOrganization[organization].organization,
            connection: environment.oktaOrganization[organization].connection,
            redirect_uri: window.location.origin.toString() + '/login/okta/auth'
          }
        });
      }
    });

    return false;
  }
}
